<div class="search-items-container" [ngClass]="{
    'main-menu': contentView === 'mainMenu',
    'sub-menu': contentView === 'subMenu'
}">
    <ng-container *ngIf="searchResults.length > 0; else showEmpty">
        <ng-container *ngFor="let item of searchResults;">
            <div class="search-item" (click)="navigateToScreen(item)">
                <div class="search-text">{{item.text | translate}}</div>
                <div class="search-path">
                    <ng-container *ngFor="let path of item?.pathInBreadCrumb; let i = index;">
                        {{(path | translate) + ((i !== item.pathInBreadCrumb.length - 1) ? ' > ' : '')}}
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #showEmpty>
        <div class="empty-result">{{ ('ZeroResultFor' | translate) + ' " ' + searchValue + ' " ' }}</div>
    </ng-template>
</div>